export const UOM_REQUIRED_MESSAGE = 'UOM is required.';
//# sourceMappingURL=uom-required-message.js.map